import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import withRouter from '../../lib/withRouter'

class MenuLink extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired
  }

  render() {
    const { title, path } = this.props

    if (this.props.location.pathname === path) {
      return (
        <span className="pure-menu-disabled pure-menu-link menu-current">{title}</span>
      )
    }

    return (
      <Link className="pure-menu-link menu-link" title={title} to={path}>{title}</Link>
    )
  }
}

export default withRouter(MenuLink)
